import store from "@/state/store";

export default [
    {
        path: '/employee/order-form',
        name: 'employee_order_form',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/employee/orderFormView.vue'),
    },
]
